import { authService } from "@/libs/ws/authService";
import { pushService } from "@/libs/ws/pushService";

// Registra el service worker de la PWA. Sin él la app funciona igual, solo pierde el modo offline y las push.
export function registerServiceWorker() {
  // En desarrollo interferiría con el hot reload
  if (process.env.NODE_ENV == "development") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .then(() => {
        if (authService.isAuthenticated()) return pushService.sync();
      })
      .catch((e) => console.log(e));
  });
}
